import { Slide } from 'components/UI/V2/Carousel/Slide';

const INFO_BOX_STYLE =
    'display:inline-flex;align-items:flex-start;gap:8px;border:2px solid #BCB8AE;border-radius:12px;padding:10px 14px;margin-top:12px;';

const INFO_ICON =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="flex-shrink:0;margin-top:2px"><circle cx="8" cy="8" r="8" fill="#92B4A7"/><text x="8" y="12" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold" font-family="serif">i</text></svg>';

const INFO_TEXT =
    '<span style="font-size:14px;line-height:1.5;color:#444">Need help moving over your client list? <a href="/clients?import=true">Click here</a> to start or <a href="mailto:help@cuddlesapp.com">contact us</a> and our team will help import your clients for free.</span>';

const SLIDE1_DESCRIPTION = `Create a pet parent profile with either an email <strong><u><i>or</i></u></strong> phone number. You can also add emergency contacts, and internal-use tags like 'VIP' or 'No Show'.<br><span style="${INFO_BOX_STYLE}">${INFO_ICON}${INFO_TEXT}</span>`;

export const clientSlides: Slide[] = [
    {
        id: 1,
        stepNumber: 1,
        title: 'Add pet parent information.',
        description: SLIDE1_DESCRIPTION,
        image: 'images/sliders/client/slider-client-1.jpg'
    },
    {
        id: 2,
        stepNumber: 2,
        title: 'Add multiple pets under one family.',
        description:
            'Create individual profiles for each pet. Include basic facts like their size and breed, along with internal notes, personality traits, health history, and vaccine records.',
        image: 'images/sliders/client/slider-client-2.jpg'
    }
];
